module.exports = __webpack_public_path__ + "img/logo-bd-pt.91b056f0.png";